<template>
  <div class="container" v-if="!loading">
    <div class="top-banner">
      <div class="name">小栖快赔</div>
      <div class="name-info">VIP绿色快速理赔通道</div>
      <div class="name-info">专家团队全程协助您理赔</div>
    </div>
    <div class="bg-container">
      <div class="history-list">
        <div @click="toLink('applyInfo.claimSettle')">
          <img src="../../static/images/applyInfo/a1.png" alt="" />
          <div>
            <div>我要理赔</div>
            <div>
              您有<span>{{ info.canSettleCount }}</span
              >张有效保单，根据保单完成申请
            </div>
          </div>
          <van-icon class="icon" name="arrow" />
        </div>
        <div @click="toLink('applyInfo.myClaims', 1)">
          <img src="../../static/images/applyInfo/a2.png" alt="" />
          <div>
            <div>进行中的理赔</div>
            <div>
              您有<span>{{ info.settleIngCount }}</span
              >条正在进行中的理赔
            </div>
          </div>
          <van-icon class="icon" name="arrow" />
        </div>
        <div @click="toLink('applyInfo.myClaims', 2)">
          <img src="../../static/images/applyInfo/a3.png" alt="" />
          <div>
            <div>理赔记录</div>
            <div>
              您有<span>{{ info.settleedCount }}</span
              >条历史记录
            </div>
          </div>
          <van-icon class="icon" name="arrow" />
        </div>
      </div>
      <div class="blue-title">关于小栖快赔</div>
      <div class="info-text">
        “小栖快赔”覆盖所有合作保司全险种保险产品，全方位满足用户线上报案、进度查询等服务。还有理赔客服团队7*24小时全程协助客户，切实解决理赔过程中流程繁琐、低效沟通、异议理赔等难点痛点问题，打造一站式的理赔服务模式。
      </div>
      <div class="item-title">理赔流程</div>
      <div class="step-box">
        <div>
          <span>01</span>
          <img src="../../static/images/applyInfo/step1.png" alt="" />
          <div>
            <p>线上申请</p>
            <p>一健报案</p>
          </div>
        </div>
        <div>
          <span>02</span>
          <img src="../../static/images/applyInfo/step2.png" alt="" />
          <div>
            <p>填写信息</p>
            <p>申请理赔</p>
          </div>
        </div>
        <div>
          <span>03</span>
          <img src="../../static/images/applyInfo/step3.png" alt="" />
          <div>
            <p>查询进度</p>
            <p>理赔结案</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-info">
      <div class="item-title guide-title">理赔指引</div>
      <div class="apply-guide">
        <div class="guide1-box">
          <img
            class="guide1"
            src="../../static/images/applyInfo/guide1.png"
            alt=""
          />
          <div>
            <div>申请理赔</div>
            <div>一键报案</div>
          </div>
        </div>
        <img class="g1" src="../../static/images/applyInfo/g1.png" alt="" />
        <div class="guide2-box">
          <div>
            <div>输入相关信息</div>
            <div>查询对应保单</div>
          </div>
          <img
            class="guide2"
            src="../../static/images/applyInfo/guide2.png"
            alt=""
          />
        </div>
        <img class="g2" src="../../static/images/applyInfo/g2.png" alt="" />
        <div class="guide3-box">
          <img
            class="guide3"
            src="../../static/images/applyInfo/guide3.png"
            alt=""
          />
          <div>
            <div>选择理赔保单</div>
            <div>点击申请理赔</div>
          </div>
        </div>
        <img class="g1" src="../../static/images/applyInfo/g1.png" alt="" />
        <div class="guide4-box">
          <div>
            <div>填写理赔信息</div>
            <div>提交相关资料</div>
          </div>
          <img
            class="guide4"
            src="../../static/images/applyInfo/guide4.png"
            alt=""
          />
        </div>
      </div>
      <div class="item-title">理赔服务</div>
      <div class="circle-arrow">
        <div>
          <div>保险评估公司</div>
          <div>律师事务所</div>
        </div>
        <div>协赔团队</div>
      </div>
    </div>
    <div class="bottom-container">
      <div class="item-title">理赔问答</div>
      <div class="bottom-box">
        <div>
          <div class="bottom-item-title">
            <span>Q1</span>申请理赔后，多久可以收到消息通知？
          </div>
          <div>
            对于事故责任明确，理赔资料齐全的案件，审核周期小额快赔类一般为1-3个工作日，普通类一般为5-7个工作日，重大类一般为20-22个工作日，请您耐心等待。
          </div>
        </div>
        <div>
          <div class="bottom-item-title">
            <span>Q2</span>网上投保，影响异地赔付么？
          </div>
          <div>
            没有影响，专业理赔客服团队7*24小时全程协助指导您收集和递交材料。根据案件情况，部分案件还可以在线影像结案，无需寄送纸质材料，不用担心异地赔付的问题。
          </div>
        </div>
        <div>
          <div class="bottom-item-title">
            <span>Q3</span>理赔注意事项有哪些？
          </div>
          <div>1.报案及时，出险后填写相关理赔信息。</div>
          <div>
            2.材料真实且齐全，按照要求准备齐全材料提交，保险公司审核无误，按照合同约定给付保险金。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {share,common } from "@/api/mixins";
export default {
  mixins: [share,common],
  data() {
    return {
      loading: true,
      info: {},
    };
  },
  created() {
    if(!this.checkLogin()){
      return;
    }
    this.getInfo();
  },
  mounted() {
    const shareData = {
      title: "小栖快赔",
      link: location.href,
      content:
        "覆盖所有合作保司全险种保险产品，全方位满足用户线上报案、进度查询等服务，更有理赔客服团队7*24小时全程为您服务。",
      logo:location.origin+"/m/public/images/new-share-logo.png",
    };
    this.shareInit(shareData, true);
  },
  methods: {
    getInfo() {
      this.$http({
        type: "PUT",
        url: "/api/compensation/count",
        data: {
          mechanCode: this.$route.query.c,
        },
      })
        .then((res) => {
          this.loading = false;
          this.info = res.data;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    toLink(name, id) {
      if (id) {
        this.$router.push({
          name: name,
          query: { id: id, code: this.$route.query.c },
        });
      } else {
        this.$router.push({ name: name, query: { code: this.$route.query.c } });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.container {
  background-color: #fff;
}
.top-banner {
  width: 100%;
  height: 300px;
  background: url("../../static/images/applyInfo/title.png") no-repeat 0 0/100%
    100%;
  padding-left: 59px;
  padding-top: 67px;
  color: #fff;
  letter-spacing: 2px;
  .name {
    font-size: 54px;
    font-weight: 500;
  }
  .name-info {
    font-size: 34px;
    font-weight: 400;
  }
}
.bg-container {
  background-color: #eff4ff;
  margin-top: -20px;
  border-radius: 20px;
  padding: 50px 0 39px;
  .history-list {
    background-color: #fff;
    margin: 0 30px 40px;
    border-radius: 10px;
    > div {
      display: flex;
      align-items: center;
      height: 167px;
      margin: 0 30px;
      border-bottom: 1px solid #ececec;
      &:last-child {
        border: none;
      }
      img {
        width: 84px;
        height: 84px;
        margin-right: 34px;
      }
      div {
        div:first-child {
          font-weight: bold;
          font-size: 32px;
          color: #333;
        }
        div:last-child {
          font-weight: 400;
          font-size: 24px;
          color: #666;
          span {
            color: #ff7134;
          }
        }
      }
      .icon {
        color: #bfbfbf;
        margin-left: auto;
      }
    }
  }
  .blue-title {
    width: 260px;
    height: 64px;
    line-height: 64px;
    color: #fff;
    font-size: 32px;
    padding-left: 30px;
    font-weight: 500;
    background: linear-gradient(188deg, #23a2ff 0%, #236dff 100%);
    opacity: 1;
    border-radius: 0px 32px 32px 0px;
  }
  .info-text {
    margin: 30px 30px 59px;
    font-weight: 400;
    line-height: 50px;
    color: #515c6f;
    font-size: 28px;
  }
  .step-box {
    display: flex;
    padding: 0 30px;
    justify-content: space-between;
    margin-top: 30px;
    > div {
      width: 216px;
      height: 261px;
      background-color: #fff;
      border-radius: 10px;
      span {
        display: inline-block;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #fa8a68;
        opacity: 1;
        color: #fff;
        font-size: 32px;
        font-weight: bold;
        border-radius: 10px 0px 20px 0px;
      }
      img {
        display: block;
        margin: 0 auto 29px;
        width: 60px;
        height: 60px;
      }
      div {
        font-size: 30px;
        font-weight: 400;
        line-height: 40px;
        color: #333333;
        text-align: center;
      }
    }
  }
}
.item-title {
  font-size: 36px;
  color: #333333;
  padding-left: 30px;
  font-weight: bold;
}
.guide-title {
  margin: 49px 0 46px;
}
.apply-info {
  font-size: 30px;
  color: #3c464f;
  .apply-guide {
    margin-bottom: 79px;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      font-size: 30px;
      color: #333;
    }
    .guide1-box {
      padding: 0 118px 0 55px;
    }
    .guide2-box {
      padding: 0 73px 0 80px;
    }
    .guide3-box {
      padding: 0 89px 0 55px;
    }
    .guide4-box {
      padding: 0 73px 0 80px;
    }
    .guide1 {
      width: 406px;
      height: 389px;
    }
    .guide2 {
      width: 300px;
      height: 378px;
    }
    .guide3 {
      width: 375px;
      height: 387px;
    }
    .guide4 {
      width: 300px;
      height: 378px;
    }
    .g1,
    .g2 {
      display: block;
      width: 334px;
      height: 58px;
      margin: 10px auto;
    }
  }
  .circle-arrow {
    padding-bottom: 88px;
    margin-top: 40px;
    > div:first-child {
      display: flex;
      justify-content: space-between;
      height: 393px;
      padding: 135px 70px 0 45px;
      background: url("../../static/images/applyInfo/circle-arrow.png")
        no-repeat center/385px 393px;
    }
    img {
      display: block;
      width: 385px;
      height: 393px;
    }
    > div:last-child {
      text-align: center;
      margin-top: 10px;
    }
  }
}
.bottom-container {
  position: relative;
  z-index: 88;
  background-color: #eff4ff;
  margin-top: -20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 30px 0 58px;
  .bottom-box {
    background-color: #fff;
    margin: 30px 30px 0;
    border-radius: 10px;
    > div {
      padding: 30px 30px 0;
      .bottom-item-title {
        display: flex;
        align-items: center;
        font-size: 32px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
        span {
          width: 48px;
          height: 34px;
          text-align: center;
          background: #fa8a68;
          opacity: 1;
          font-size: 24px;
          border-radius: 17px 17px 0px 17px;
          color: #fff;
          margin-right: 10px;
          font-weight: normal;
        }
      }
      div {
        color: #666;
        font-size: 28px;
        font-weight: 400;
        line-height: 40px;
        &:last-child {
          padding-bottom: 30px;
          border-bottom: 1px dashed #d9e1f4;
        }
      }
      &:last-child {
        div {
          &:last-child {
            border-bottom: none;
            margin-top: 15px;
          }
        }
      }
    }
  }
}
</style>
